// COFRE DE SEGREDOS (2026-08-20) — wrappers das actions seg_*.
//
// ⚠️ Rota diferente da do acervo: o cofre entra por
// `POST /comercial/propostas-geradas` (o roteador genérico por `body.action`,
// onde as ~400 actions e as `exp_*` já moram), enquanto os documentos entram
// por `POST /comercial/documentos`. Não é inconsistência gratuita: criar
// recurso novo no API Gateway é ritual manual, e a rota é só transporte.
//
// 🔒 O valor do segredo NÃO vem na listagem. Ele só existe na resposta de
//    `revelarSegredo`, uma vez, e essa chamada fica registrada no servidor.
import axios from 'axios';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';

export type TipoSegredo = 'senha_certificado' | 'senha_portal' | 'token' | 'pin';

export interface Segredo {
  id: number;
  rotulo: string;
  tipo: TipoSegredo;
  titular: string | null;
  usuario_login: string | null;
  url_portal: string | null;
  documento_id: number | null;
  documento_codigo: string | null;
  documento_titulo: string | null;
  validade: string | null;
  observacao: string | null;
  restrito: boolean;
  criado_por: string;
  criado_em: string;
  atualizado_em: string | null;
  atualizado_por: string | null;
  revelado_em: string | null;
}

export interface AcessoCofre {
  id: number;
  segredo_id: number | null;
  rotulo_snap: string;
  usuario_email: string;
  acao: 'criou' | 'alterou' | 'revelou' | 'baixou_arquivo' | 'excluiu';
  detalhe: string | null;
  em: string;
}

async function chamar<T = any>(action: string, body: Record<string, any> = {}): Promise<T> {
  const token = await getToken();
  const r = await axios.post(`${API_URL}/comercial/propostas-geradas`,
    { action, ...body }, { headers: { Authorization: token } });
  return r.data.body ? JSON.parse(r.data.body) : r.data;
}

export const listarSegredos = (f: { tipo?: string; busca?: string } = {}) =>
  chamar<{ segredos: Segredo[]; pode_revelar: boolean; pode_gerenciar: boolean }>('seg_listar', f);

/** Devolve o valor em texto UMA vez. A chamada é registrada em cofre.acessos. */
export const revelarSegredo = (id: number, motivo?: string) =>
  chamar<{ valor: string; rotulo: string }>('seg_revelar', { id, motivo });

export const salvarSegredo = (p: Record<string, any>) =>
  chamar<{ id: number; criado?: boolean; atualizado?: boolean; valor_trocado?: boolean }>('seg_salvar', p);

/** A AWS guarda o segredo por mais `recuperavel_por_dias` antes de apagar de
 *  vez — a tela mostra esse prazo, senão quem excluiu por engano acha que
 *  perdeu a senha (e quem quis excluir não sabe que ainda está pagando). */
export const excluirSegredo = (id: number, motivo?: string) =>
  chamar<{ excluido: boolean; recuperavel_por_dias?: number }>('seg_excluir', { id, motivo });

export const listarAcessosCofre = (f: { segredo_id?: number; limite?: number } = {}) =>
  chamar<{ acessos: AcessoCofre[] }>('seg_acessos', f);

export const TIPO_SEGREDO: Record<TipoSegredo, { label: string; cor: string }> = {
  senha_certificado: { label: 'Senha de certificado', cor: 'gold' },
  senha_portal:      { label: 'Senha de portal',      cor: 'blue' },
  token:             { label: 'Token',                cor: 'purple' },
  pin:               { label: 'PIN',                  cor: 'default' },
};
